export const COLORS = {
    primary: '#0B3954',
    secondary: '#087E8B',
    accent: '#FF5A5F',
    light: '#F5F5F5',
    dark: '#333333'
  };
  
  export const CATEGORIES = {
    ALL: 'all',
    UNISEX: 'unisex',
    WOMEN: 'women',
    MEN: 'men'
  };

  export const TYPES = {
    ALL: 'all',
    SCRUB_TOP: 'scrub_top',
    SCRUB_PANT: 'scrub_pant',
    SCRUB_SET: 'scrub_set',
    WHITE_COAT: 'white_coat',
    SCRUB_JACKET: 'scrub_jacket',
  };
  
  export const BADGE_STYLES = {
    unisex: 'bg-teal-600',
    women: 'bg-pink-400',
    men: 'bg-blue-500'
  };